import React, { useCallback } from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import { EmailFieldContent } from '@shared/components/EmailFieldContent';

export const Email = <T extends FieldValues>({
  name,
  control,
  defaultValue,
  errorMessage,
  isDisabled,
  setWidth,
}: UseControllerProps<T> & { errorMessage?: string; isDisabled?: boolean; setWidth?: boolean }) => {
  const renderField = useCallback(
    ({ field: { value, onChange } }) => (
      <EmailFieldContent
        value={value}
        onChange={onChange}
        editable={!isDisabled}
        errorMessage={errorMessage}
        label="E-post"
        setWidth={setWidth}
      />
    ),
    [isDisabled, errorMessage, setWidth],
  );

  return <Controller name={name} control={control} defaultValue={defaultValue} render={renderField} />;
};
